import React, { Component } from 'react';
import logo from './images/L.svg';
import Loading from './Loading';

class Draft extends Component {
  constructor(props) {
    super(props);

    this.state = {team1Name: '', team2Name: '', matchName: '', locale: 'en_US', draft: null, loading: false};
  }
  create() {
    this.setState({loading: true});
    fetch(`${this.props.host}/draft`, {
      method: 'POST',
      headers: {
       'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        team1Name: this.state.team1Name,
        team2Name: this.state.team2Name,
        matchName: this.state.matchName
      })
    })
    .then(res => res.json())
    .then(json => this.setState({draft: json, loading: false}))
    .catch(() => this.setState({loading: false}));
  }
  render() {
    const locales = [['English', 'en_US'], ['Bahasa Indonesia', 'id_ID'], ['Bahasa Malaysia', 'ms_MY'], ['ภาษาไทย', 'th_TH'], ['Tiếng Việt', 'vn_VN'], ['简体字', 'zh_MY'], ['繁體字', 'zh_TW']];

    return (
      <div className="create">
        <img src={logo} alt="League of Legends" />
        {this.state.draft ? <div>
          <label htmlFor="blue_team_name">Pick & ban link<span>{this.state.team1Name}</span></label>
          <input type="text" id="blue_team_name" onFocus={e=>e.target.select()} value={`${location.protocol}//${location.host}/?draft=${this.state.draft.id}&auth=${this.state.draft.auth[0]}&locale=${this.state.locale}`} readOnly />
          <label htmlFor="red_team_name">Pick & ban link<span>{this.state.team2Name}</span></label>
          <input type="text" id="red_team_name" onFocus={e=>e.target.select()} value={`${location.protocol}//${location.host}/?draft=${this.state.draft.id}&auth=${this.state.draft.auth[1]}&locale=${this.state.locale}`} readOnly />
          <label htmlFor="match_name">Spectator link</label>
          <input type="text" id="match_name" onFocus={e=>e.target.select()} value={`${location.protocol}//${location.host}/?draft=${this.state.draft.id}&locale=${this.state.locale}`} readOnly />
        </div> :
        <div>
          <label htmlFor="blue_team_name">Blue team name</label>
          <input type="text" id="blue_team_name" value={this.state.team1Name} maxLength={30} onChange={e => this.setState({team1Name: e.target.value})} />
          <label htmlFor="red_team_name">Red team name</label>
          <input type="text" id="red_team_name" value={this.state.team2Name} maxLength={30} onChange={e => this.setState({team2Name: e.target.value})} />
          <label htmlFor="match_name">Match name</label>
          <input type="text" id="match_name" value={this.state.matchName} maxLength={30} onChange={e => this.setState({matchName: e.target.value})} />
          <label htmlFor="locale">Locale</label>
          <select value={this.state.locale} onChange={e => this.setState({locale: e.target.value})} >
            {locales.map(l => <option value={l[1]} key={l[1]}>{l[0]}</option>)}
          </select>
          {this.state.loading ? <Loading /> : <button className="confirm" disabled={!this.state.team1Name.length || !this.state.team2Name.length || !this.state.matchName.length} onClick={this.create.bind(this)}>Confirm</button>}
        </div>}
      </div>
    );
  }
}

export default Draft;



// WEBPACK FOOTER //
// ./src/Create.js